import React, { Component } from 'react';
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu/modules";
import InlineEdit from './InlineEdit';
import { Maybe } from 'flowr'
import { dispatch } from '@rematch/core';
class MenuNode extends Component {
	constructor(props) {
        super(props);
        this.state = {
           highLightLabelOnDrag:false
        };
	}

	dragstart_handler = (ev) => {
		this.setState({highLightLabelOnDrag:true})
		dispatch.app.setCollapsedResourcePaneIndexTemp(null);
		dispatch.lifeCycle.showResourecePane(null);
		ev.dataTransfer.setData("text/plain", ev.target.id);
	}

	render() {
		const { label, id, handlePeer, handleAdd, handleDelete, dataChanged, handleDnD, depth, treeLength, validatioFunction, status, name, isLeafCommunity } = this.props;
		
		function dragover_handler(ev, data) {
			if (status !== 0)
				return;
			ev.preventDefault();
			ev.dataTransfer.dropEffect = "move"
		}

		function drop_handler(ev, data) {
			ev.preventDefault();
			const sourceId = ev.dataTransfer.getData("text/plain");
			handleDnD(sourceId, id);
		}

		return (
			<div>
				<Maybe when={status === 0}>
					<ContextMenu id={`contextMenu_${id}`}>
						<Maybe when={depth < 1}>
							<MenuItem data={{ id }} onClick={handlePeer}>
								{this.props.element === "activities" && "Add Phase"}
								{this.props.element === "communities" && "Add Group"}
							</MenuItem>
						</Maybe>
						<Maybe when={depth < 1}>
							<MenuItem data={{ id }} onClick={handleAdd}>
								{this.props.element === "activities" && "Add Stage"}
								{this.props.element === "communities" && "Add Sub Group"}
							</MenuItem>
						</Maybe>
						<Maybe when={treeLength !== 1 || depth > 0}>
							<MenuItem data={{ id, name, isLeafCommunity }} onClick={handleDelete}>
								Remove Element
                            </MenuItem>
						</Maybe>
					</ContextMenu>
				</Maybe>
				{id &&
					<ContextMenuTrigger id={`contextMenu_${id}`} holdToDisplay={-1} style={{ "border-left": "4px solid #333333" }}>
						<div className={`well ${this.props.setUniqueId === id.toString()|| this.state.highLightLabelOnDrag  ? "setActiveLabel" : ""} `} id={id.toString()} onDrop={drop_handler} onDragOver={dragover_handler} draggable="true" onDragStart={this.dragstart_handler} onM style={{ "transform": "translate(0, 0)", "z-index": 0 }}>
							<div id={this.props.automationId}>
								<InlineEdit
									activeClassName="editing"
									text={label}
									colorTag={depth > 0 ? this.props.colorTag : ""}
									paramName="message"
									data={{ id }}
									change={dataChanged}
									validationFunction={validatioFunction}
									status={status}
									elementType={this.props.element}
									editing={this.props.setEditMode}
									setEditModeFalse={this.props.setEditModeFalse}
									resourcPane={this.props.resourcPane}
									style={{
										minWidth: 150,
										width: '100%',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										display: 'block',
										margin: 0,
										padding: 5,
										outline: 0,
										borderLeft: "4px solid" + this.props.colorTag,
										//background: 'white'
									}}
								/>
							</div>
						</div>
					</ContextMenuTrigger>
				}
			</div>
		);
	};
}

export default MenuNode;